module.exports = __webpack_public_path__ + "static/media/kwallet-logo.4dad36ce.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/kwallet-logo.svg
 ** module id = 463
 ** module chunks = 0
 **/